/* eslint-disable i18n/no-russian-character */
const ruSystem = {
    connection: {
        isOfflineConfirm: "Интернет-соединение не обнаружено. Всё равно перейти по ссылке?",
        offlineRegime: "Оффлайн режим",
    },
    data: {
        errors: {
            forbidden: "Действие запрещено",
        },
    },
    serviceWorker: {
        update: "Доступна новая версия портала. Обновимся?",
    },
    dateTime: {
        errors: {
            invalidDate: "Неверная дата",
            endDateBeforeStartDate: "Дата окончания не может быть раньше даты начала",
        },
    },
    timeDiff: {
        title: "Расхождение времени",
        description:
            "Время на вашем устройстве расходится с сервером более чем на 5 минут. Проверьте настройки даты, времени и часового пояса.",
        serverTime: "Время на сервере: %s",
        localTime: "Время на вашем устройстве: %s",
    },
    biometric: {
        error: "❌ Ошибка биометрической аутентификации",
    },
};

export default ruSystem;
